import Vue from 'vue'

Vue.filter('strEmpty', (value) => {
  return value || '-'
})
